module.exports = __webpack_public_path__ + "7319fd1e070bc7e6301763a7699e1a87.pdf";